module.exports = __webpack_public_path__ + "images/pattern-2.73ec96f191003f61754d95720fec1789.jpg";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/images/pattern-2.jpg
// module id = 1024
// module chunks = 0